export function setupSuscripcion() {
    //suscripcion footer
    var suscripcion_email_btn = document.querySelector(
        "#suscripcion_email_btn"
    );
    var suscripcion_form = document.querySelector(
        "#mc-embedded-subscribe-form"
    );
    var newsletter_form__gracias = document.querySelector(
        ".newsletter_form__gracias"
    );

    if (suscripcion_email_btn)
        suscripcion_email_btn.addEventListener("click", function () {
            newsletter_form__gracias.classList.add("mostrar");
            suscripcion_form.classList.add("hidden");
        });
}
